// src/Components/BottomTabBar.jsx
// Narrow-viewport nav — the same destinations AppShell renders inline in the
// header on desktop widths, shown here as a fixed bottom bar instead (hidden
// via `sm:hidden` once the header nav takes over).
import React from "react";
import { NavLink } from "react-router-dom";

const BottomTabBar = ({ tabs }) => {
  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 bg-brand-surface border-t border-brand-border z-40 flex items-stretch">
      {tabs.map(({ key, to, label, icon: Icon }) => (
        <NavLink
          key={key}
          to={to}
          end={to === "/"}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-xs font-semibold transition-colors ${
              isActive ? "text-brand-accent" : "text-brand-textSecondary"
            }`
          }
        >
          <Icon size={20} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
};

export default BottomTabBar;
